import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import PageHeader from 'components/global/PageHeader';
import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ADMIN } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const ReferralList = () => {
	const columns = useMemo(
		() => [
			{
				Header: 'referrerClientName',
				accessor: 'senderName',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'referrerCompanyId',
				accessor: 'senderCompanyID',
				filterType: FilterType.number,
				showOnMobile: true,
				showCopyButton: true
			},
			{
				Header: 'referrerEmail',
				accessor: 'senderEmail',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'referralBlockedState',
				accessor: 'referralBlockedStatus',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'transactionDate',
				accessor: 'transactionDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATE,
				showOnMobile: true
			},
			{
				Header: 'refereeClient',
				accessor: 'receiverName',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'refereeEmail',
				accessor: 'receiverEmail',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'referee',
				accessor: 'onboardingStatus',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'refereeEarnDate',
				accessor: 'receiverEarnDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATE,
				showOnMobile: true
			},
			{
				Header: 'refereedIpAddress',
				accessor: 'IPAddress',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'referralIPAddress',
				accessor: 'referralIPAddress',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'refereeStatus',
				accessor: 'status',
				filterType: FilterType.string,
				showOnMobile: true
			}
		],
		[]
	);

	return (
		<TabTableContainer>
			<PageHeader
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/referral-icon.json.gz"
				title="referralsListing"
			/>
			<DynamicList
				id={DYNAMICLISTS.REFERRAL_LIST}
				columns={columns}
				fetchUrl={ADMIN.REFERRALS.REFERRAL_LIST}
				exportName="referral-list"
				actionObjectType={ACTION_OBJECT_TYPES.ADMIN}
			/>
		</TabTableContainer>
	);
};

export default ReferralList;
